import { Link as ChakraLink } from '@chakra-ui/react';
import type { LinkProps as ChakraLinkProps } from '@chakra-ui/react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { colors } from '../colors';

export const Link: React.FC<
  { children: React.ReactNode; to: string } & ChakraLinkProps
> = ({ children, to, ...chakraLinkProps }) => {
  return (
    <ChakraLink
      {...chakraLinkProps}
      as={RouterLink}
      to={to}
      fontWeight={chakraLinkProps.fontWeight || '500'}
      color={chakraLinkProps.color || colors.info}
    >
      {children}
    </ChakraLink>
  );
};
